import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryStrip() {
  return (
    <section className="bg-background-100/70 py-14 md:py-16">
      <div className="container-editorial">
        <SectionHeading
          eyebrow="Content Channels"
          title="按栏目找内幕"
          desc="不同领域的爆料逻辑并不一样。选一个你关心的话题，直接从最新线索开始读。"
          actionLabel="进入爆料中心"
          actionHref="/rumors"
        />

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/rumors?cat=${cat.slug}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-background-50 animate-fade-up"
              style={{ animationDelay: `${index * 55}ms` }}
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                <i className={`${cat.icon} text-xl`} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950">{cat.name}</span>
                  <i className="ri-arrow-right-line text-base text-foreground-400 transition-all group-hover:translate-x-0.5 group-hover:text-primary-600" />
                </span>
                <span className="mt-1 block text-sm leading-relaxed text-foreground-600">{cat.desc}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}